// Imports
//=require ../source/js/modernizr-custom.js
//=require jquery/dist/jquery.min.js
//=require jquery-validation/dist/jquery.validate.min.js
//=require jquery-mask-plugin/dist/jquery.mask.min.js

function setInputFilter(textbox, inputFilter) {
    ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty('oldValue')) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
    });
}

/**
 * Focus on keydown
 */

let keyboardNavigation = false;

$(document).on('keydown', function (e) {
    if (e.key == 'Tab') {
        $('body').addClass('is-keyboard-pressed');
        keyboardNavigation = true;
    };
});

$(document).on('click mousedown', function (e) {
    var $target = $(e.target);
    if ($target.is(':radio, :checkbox, :button, a[href="#"]')) {
        if (keyboardNavigation == false) {
            $('body').removeClass('is-keyboard-pressed');
            keyboardNavigation = false;
        }
    } else {
        $('body').removeClass('is-keyboard-pressed');
        keyboardNavigation = false;
    }
});
$('input[type=radio], input[type=checkbox], button[type="button"], a[href="#"]').on('keydown', function (e) {
    $('body').addClass('is-keyboard-pressed');
    keyboardNavigation = true;
});


// DOM
var MyApp = {

    onlyNumbers: function () {
        $('.only-numbers').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9]*$/.test(value);
            });
        });
    },
    onlyLetters: function () {
        $('.only-letters').each(function () {
            setInputFilter(this, function (value) {
                return /^[a-zA-ZáéíóúÁÉÍÓÚ\'´ñÑäëïöüÄËÏÖÜ \-]*$/.test(value);
            });
        });
    },
    onlyAlphaNumeric: function () {
        $('.only-alpha-numeric').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9a-zA-Z]*$/.test(value);
            });
        });
    },
    onlyPhone: function () {
        $('.only-phone').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\-]*$/.test(value);
            });
        });
        $('.only-phone').mask('000-000-0000');
    },
    onlyDate: function () {
        $('.only-date').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\/]*$/.test(value);
            });
        });
    },
    form: function () {
        $.validator.methods.email = function (value, element) {
            return this.optional(element) || /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i.test(value);
        }

        $('.form').each(function () {
            $(this).validate({
                errorClass: 'form__error',
                validClass: 'form__valid',
                submitHandler: function (form) {
                    $(form).addClass('form_loading');
                    form.submit();
                }
            });
        });

        if ($('#zipcode').length) {
            $('#zipcode').rules('add', {
                required: true,
                digits: true,
                minlength: 3,
                maxlength: 5,
                remote: {
                    url: 'https://thorv2.confiejarvis.com/thor/javascript?',
                    data: {
                        zipcode: function () { return $('#zipcode').val(); }
                    },
                    dataFilter: function (data) {
                        if (data === "1") {
                            $('.hero__hashtag').removeClass('is-hidden');
                            return '"true"';
                        } else {
                            $('.hero__hashtag').addClass('is-hidden');
                            return '"Enter a valid zip code"';
                        }
                    }
                },
                messages: {
                    required: 'Enter your zip code'
                }
            });

            $('#zipcode').on('input', function () {
                if (!$('.form').valid()) {
                    $('.hero__hashtag').addClass('is-hidden');
                } else {
                    $('.hero__hashtag').removeClass('is-hidden');
                }
            });
        }

        if ($('#zipcodeBanner').length) {
            $('#zipcodeBanner').rules('add', {
                required: true,
                digits: true,
                minlength: 3,
                maxlength: 5,
                remote: {
                    url: 'https://thorv2.confiejarvis.com/thor/javascript?',
                    data: {
                        zipcode: function () { return $('#zipcodeBanner').val(); }
                    },
                    dataFilter: function (data) {
                        if (data === "1") {
                            return '"true"';
                        }
                        return '"Enter a valid zip code"';
                    }
                },
                messages: {
                    required: 'Enter your zip code'
                }
            });
        }

        if ($('#firstName').length) {
            $('#firstName').rules('add', {
                required: true,
                minlength: 2,
                messages: {
                    required: 'Enter your first name'
                }
            });
        }
        if ($('#lastName').length) {
            $('#lastName').rules('add', {
                required: true,
                minlength: 2,
                messages: {
                    required: 'Enter your last name'
                }
            });
        }
        if ($('#email').length) {
            $('#email').rules('add', {
                required: true,
                minlength: 3,
                maxlength: 120,
                messages: {
                    required: 'Enter your email'
                }
            });
        }
        if ($('#phone').length) {
            $('#phone').rules('add', {
                required: true,
                minlength: 12,
                maxlength: 12,
                messages: {
                    required: 'Enter your phone number',
                    minlength: 'You must enter 10 digits',
                    maxlength: 'You must enter 10 digits',
                }
            });
        }
    },
    flotingLabel: function () {
        $('.form input').on('input', function () {
            if ($(this).val() != '') {
                $(this).closest('.form__item').addClass('form__item_filled');
            } else {
                $(this).closest('.form__item').removeClass('form__item_filled');
            }
        });

        $('.form select').on('change', function () {
            if ($(this).val() != '') {
                $(this).closest('.form__item').addClass('form__item_filled');
            } else {
                $(this).closest('.form__item').removeClass('form__item_filled');
            }
        });

        $('.form input, .form select').each(function () {
            if ($(this).val() != '') {
                $(this).closest('.form__item').addClass('form__item_filled');
            }
        });
    }
}
//OSANO
const osanoTrigger = {
    trigger: document.querySelector('.js-osano-trigger'),
    init() {
        this.trigger?.addEventListener('click', event => {
            event.preventDefault();
            Osano.cm.showDoNotSell();
            const closeButtonDialog = document.querySelector('.osano-cm-info-dialog .osano-cm-close');
            closeButtonDialog?.focus();
        });
    }
};

window.addEventListener('load', event => {
    osanoTrigger.init();
});

// On ready

$(function () {

    if ($('.only-numbers').length) {
        MyApp.onlyNumbers();
    }
    if ($('.only-letters').length) {
        MyApp.onlyLetters();
    }
    if ($('.only-alpha-numeric').length) {
        MyApp.onlyAlphaNumeric();
    }
    if ($('.only-phone').length) {
        MyApp.onlyPhone();
    }
    if ($('.form').length) {
        MyApp.form();
        MyApp.flotingLabel();
    }
});